__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@frontend/shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aws-amplify/ui-react", "6.1.11", () => (Promise.all([__webpack_require__.e(4967), __webpack_require__.e(3364), __webpack_require__.e(9720), __webpack_require__.e(7900), __webpack_require__.e(1830), __webpack_require__.e(4548)]).then(() => (() => (__webpack_require__(9720))))));
			register("@coworker/shared-library", "0.0.1", () => (Promise.all([__webpack_require__.e(7900), __webpack_require__.e(8881), __webpack_require__.e(7014)]).then(() => (() => (__webpack_require__(7014))))));
			register("aws-amplify", "6.3.2", () => (Promise.all([__webpack_require__.e(4967), __webpack_require__.e(5754)]).then(() => (() => (__webpack_require__(5754))))));
			register("axios", "1.6.5", () => (__webpack_require__.e(4578).then(() => (() => (__webpack_require__(4578))))));
			register("axios", "1.7.7", () => (__webpack_require__.e(871).then(() => (() => (__webpack_require__(871))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(8316), __webpack_require__.e(7900)]).then(() => (() => (__webpack_require__(8316))))));
			register("react-router-dom", "6.21.3", () => (Promise.all([__webpack_require__.e(6034), __webpack_require__.e(7900), __webpack_require__.e(1830)]).then(() => (() => (__webpack_require__(6034))))));
			register("react", "18.2.0", () => (__webpack_require__.e(2784).then(() => (() => (__webpack_require__(2784))))));
			register("socket.io-client", "^4.7.2", () => (() => (__webpack_require__(3954))), 1);
			register("styled-components", "6.1.8", () => (Promise.all([__webpack_require__.e(6880), __webpack_require__.e(7900)]).then(() => (() => (__webpack_require__(6880))))));
			register("uniqid", "5.4.0", () => (__webpack_require__.e(6277).then(() => (() => (__webpack_require__(6277))))));
			initExternal(3569);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};